import { makeRequest } from "../helpers/api.helpers";

const API_URL = import.meta.env.VITE_API_URL;

type Props = {
  prefix: string;
  file: File;
  name?: string;
};

export async function sendFile(data: Props) {
  const url = `${API_URL}/document/hold`;

  const formData = new FormData();

  data?.name ?? formData.append("name", data?.name || '');

  formData.append("prefix", data.prefix);
  data?.name && formData.append("name", data.name);
  formData.append("document", data.file);

  const options = {
    method: "POST",
    body: formData,
  };

  const result = makeRequest<{ key: string }[]>(url, options);
  return result;
}
